import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import toast from 'react-hot-toast';

const Profile = () => {
  const { user, logout } = useAuth();
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChangePassword = async (e) => {
    e.preventDefault();

    if (newPassword !== confirmPassword) {
      toast.error('New passwords do not match');
      return;
    }

    if (newPassword.length < 8) {
      toast.error('Password must be at least 8 characters');
      return;
    }

    setLoading(true);
    try {
      const response = await fetch('http://localhost:5000/api/account/change-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ currentPassword, newPassword }),
      });

      const data = await response.json();

      if (data.success) {
        toast.success('Password changed successfully! Please login again.');
        setTimeout(() => logout(), 2000);
      } else {
        toast.error(data.message || 'Failed to change password');
      }
    } catch (error) {
      toast.error('Failed to change password');
    } finally {
      setLoading(false);
    }
  };

  const memberSince = user?.created_at ? new Date(user.created_at).toLocaleDateString() : 'Not available';

  return (
    <div className="dashboard-page fade-in">
      <div className="dashboard-head">
        <h1 className="dashboard-page-title">Profile Settings</h1>
        <p className="dashboard-section-subtitle">Manage your account details and password</p>
      </div>

      <section className="card dashboard-section">
        <div className="dashboard-section-header">
          <h2 className="dashboard-section-title">Account Information</h2>
          <p className="dashboard-section-subtitle">Your account details and verification status</p>
        </div>

        <div className="dashboard-section-body">
          <div className="profile-info-grid">
            <div className="profile-info-card">
              <p className="profile-info-label">Email</p>
              <p className="profile-info-value">{user?.email || 'Not set'}</p>
            </div>

            <div className="profile-info-card">
              <p className="profile-info-label">Phone</p>
              <p className="profile-info-value">{user?.phone || 'Not set'}</p>
            </div>

            <div className="profile-info-card">
              <p className="profile-info-label">KYC Status</p>
              <p
                className={`profile-info-value ${
                  user?.kyc_status === 'approved'
                    ? 'text-emerald-500'
                    : user?.kyc_status === 'pending'
                    ? 'text-yellow-500'
                    : 'text-rose-500'
                }`}
              >
                {user?.kyc_status?.toUpperCase() || 'NOT SET'}
              </p>
            </div>

            <div className="profile-info-card">
              <p className="profile-info-label">Member Since</p>
              <p className="profile-info-value">{memberSince}</p>
            </div>
          </div>
        </div>
      </section>

      <section className="card dashboard-section">
        <div className="dashboard-section-header">
          <h2 className="dashboard-section-title">Change Password</h2>
          <p className="dashboard-section-subtitle">Update your login credentials securely</p>
        </div>

        <div className="dashboard-section-body">
          <form onSubmit={handleChangePassword} className="profile-password-form">
            <div className="auth-field">
              <label className="auth-label">Current Password</label>
              <input
                type="password"
                value={currentPassword}
                onChange={(e) => setCurrentPassword(e.target.value)}
                className="auth-input"
                required
              />
            </div>

            <div className="auth-field">
              <label className="auth-label">New Password</label>
              <input
                type="password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                className="auth-input"
                required
              />
              <p className="auth-helper-text">Minimum 8 characters</p>
            </div>

            <div className="auth-field">
              <label className="auth-label">Confirm New Password</label>
              <input
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                className="auth-input"
                required
              />
            </div>

            <button
              type="submit"
              className="auth-submit-btn profile-submit-btn"
              disabled={loading}
            >
              {loading ? 'Updating...' : 'Update Password'}
            </button>
          </form>
        </div>
      </section>
    </div>
  );
};

export default Profile;